/**
 * Get country name depending on OpCo language.
 *
 * @param {String} locale
 *  Current OpCo language, picked from inlt[locale]
 * @param {String} config
 *  If omitted REACT_APP_ COUNTRY_NAME env variable use default from config.
 *  The main purpose of this setting - Jest unit tests covering.
 *  - simple string, eg. "New Zealand" or Deutschland
 *  - JSON string, eg. '{"nl":"België","fr": "Belgique","en": "Belgium"}'
 * @return {String}
 *  Country name
 */
const getCountryName = (locale, config = process.env.REACT_APP_COUNTRY_NAME) => {
  try {
    const country = JSON.parse(config);
    return country[locale];
  } catch (e) {
    return config;
  }
};

export default getCountryName;
